module.exports = __webpack_public_path__ + "img/oil_paint_4.d7e964f7.png";